export const INR_FLOW_MESSAGES = {
  signup: 'I want to register into application using INR, please proceed my request.',
  'member-invite': 'I want to do payment in INR for member invitation. Please process my request.',
  'load-wallet': 'I want to load wallet using INR. Please provide me payment link.',
  'number-purchase': 'I want to purchase the number in INR currency. Please provide payment link.',
  'suspension-payment':
    'I want to pay my overdue subscription in INR currency to reactivate my account. Please provide payment link.',
} as const;
